import React, { FunctionComponent, useState } from 'react'
import { getAuth, confirmPasswordReset } from 'firebase/auth'
import app from '../../firebase/initialize'
import { Link } from 'react-router-dom'

import { ReactComponent as Logo } from '../../components/atoms/Icons/logo.svg'
import { ReactComponent as PasswordIcon } from '../../components/atoms/Icons/password-icon.svg'

import * as S from './styled'

interface OwnProps {}

type Props = OwnProps

const SetNewPassword: FunctionComponent<Props> = () => {
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [isUpdated, setIsUpdated] = useState(false)
  const [myError, setMyError] = useState<{ isError: boolean; message: string }>()
  const auth = getAuth(app)
  const url = window.location.search
  const queryParams = new URLSearchParams(url)

  const code = queryParams.get('oobCode')

  async function handleClick() {
    if (password.length < 6) {
      setMyError({ isError: true, message: 'Lösenordet måste bestå av minst 6 tecken' })
      return
    }
    if (password !== repeatPassword) {
      setMyError({ isError: true, message: 'Lösenord och upprepat lösenord måste vara identiska' })
      return
    }

    try {
      await confirmPasswordReset(auth, code!, password)
      setIsUpdated(true)
    } catch (error: any) {
      setMyError({
        isError: true,
        message: 'Din länk för lösenordsåterställning är utgången. Vänligen hämta en ny. ',
      })
    }
  }

  return (
    <S.Wrapper>
      <S.Container>
        <Logo height="150" viewBox="0 0 550 550" />
        <S.Title>Uppdatera Lösenord</S.Title>
        {!isUpdated && (
          <>
            <S.Label>Nytt Lösenord</S.Label>
            <S.InputWrapper>
              <PasswordIcon />
              <S.Input type="password" onChange={e => setPassword(e.target.value)} required />
            </S.InputWrapper>
            <S.Label>Upprepa Lösenord</S.Label>
            <S.InputWrapper>
              <PasswordIcon />
              <S.Input type="password" onChange={e => setRepeatPassword(e.target.value)} required />
            </S.InputWrapper>
            {myError?.isError && <S.Error>{myError.message}</S.Error>}
            <S.Button onClick={handleClick}>Ändra</S.Button>
          </>
        )}

        {isUpdated && (
          <>
            <S.Title>Ditt lösenord har ändrats!</S.Title>
            <S.Paragraph>
              Klicka <Link to="/">här</Link> för att logga in!
            </S.Paragraph>
          </>
        )}
      </S.Container>
    </S.Wrapper>
  )
}

export default SetNewPassword
